/// <reference path="../../../../../../rcwebmodels/ReeferCommands.cs.d.ts" />
import * as React from 'react';
import DateFormat from 'dateformat';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import * as  EmailValidator from 'email-validator';
import $ from 'jquery';
import { RCUtils } from './../../../RCUtils';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import "react-select/dist/react-select.css";
import lodashfilter from 'lodash/filter';
var Config: any = require('../../../Config.json');
//TODO 1.maxrecords count for event,temp from db
var date = new Date();
var reeferData;
var isLastTrip = true;
var isAllTrip = false;
var isDateRange = false;
var IsDCCSSupport = null;
var IsDCCSSupportCount = 0;
var IsDLSupportCount = 0;
var oldTempCount = 0;
var oldEventCount = 0;
var isDLReeferConnect = false;
var isDLStarView = false;
var isDLDCCS = false;
var isDLBoth = true;
var dCXDownloads = false;
var errorSubmit = false;
var errSubMessage;

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

interface Options {
    label: string;
    value: string;
}

export interface DataDownloadGridState {
    rowData: server.USP_UnitCurrentConditionUI_Model[];
    DataDownload: server.TraditionalDownload;
    status: string;
    Filters: ForwardCommandParams;
    FwdCmdResult: server.ForwardCommandResultData;
    stayOpen: boolean;
    disabled: boolean;
    removeSelected: boolean;
    rtl: boolean;
    emailOptions: Options[];
    value: any[];
    oemTypeCd: string;
    oemModel: string;
    VCCheckBoxInfo: VCCheckBoxData;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
    isDLDCX: boolean;
    isDLCRReeferConnect: boolean;
    deviceType: string;
    IsScopeVisible: boolean;
    scopeValue: string;
    IsDateRangeVisible: boolean;
    IsDateRangeDisabled: boolean;
    defaultDateRanageValue: string;
    ValidState: boolean;
    scopeOptions: any[];
}

export class TraditionalDataDownload extends React.Component<any, DataDownloadGridState> {
    constructor(props: any) {
        super(props);
        $('#globalLoader').show();
        var filterSet = new ForwardCommandParams();
        var startDate = new Date();
        startDate.setDate(startDate.getDate() + -1).toLocaleString();
        var endDate = new Date();
        endDate.setDate(endDate.getDate()).toLocaleString();
        var filter: server.TraditionalDownload = {
            StartDate: startDate, EndDate: endDate, IsChecked: true, TempRecordCount: '1000', EventRecordCount: '1000', Emails: props.userEmail, DownloadType: null, QueryType: null
        };

        this.state = {
            rowData: [], DataDownload: filter, status: null, Filters: filterSet, FwdCmdResult: null, stayOpen: false, disabled: false, removeSelected: false,
            rtl: false, emailOptions: [], value: [], oemTypeCd: props.reeferData[0].ReeferOEMTypeCd, VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: [],
            oemModel: props.reeferData[0].UnitTypeCd, isDLCRReeferConnect: false, isDLDCX: false, deviceType: props.reeferData[0].DeviceType, IsScopeVisible: false, scopeValue: null, IsDateRangeVisible: true, IsDateRangeDisabled: false, defaultDateRanageValue: "--/--/----",
            ValidState: true, scopeOptions: []
        };
    }

    componentDidMount() {
        isLastTrip = true;
        isAllTrip = false;
        isDateRange = false;
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ rowData: this.props.reeferData });
            this.getEmails(this.props.userEmail, this.props.customerId);
            dCXDownloads = this.props.dCXDownloads;

            if (this.props.reeferData[0].DeviceType.trim().toUpperCase() == "TRIPLINK")
                this.getDeviceTypeValidationTripLink(this.props.reeferData, this.props.reeferData[0].DeviceType, this.props.reeferData[0].ControllerDesc.trim().toUpperCase())
            else
                this.getDeviceTypeValidation(this.props.reeferData, this.props.reeferFormatter);

            this.renderTDDGrid(this.props.reeferData);
        }

        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
        isDLReeferConnect = false;
        isDLStarView = false;
        isDLDCCS = false;
        isDLBoth = true;
        $('#globalLoader').hide();
    }


    handleSelectChange(value) {
        var tDD = this.state.DataDownload;
        tDD.Emails = value;
        if (value == '')//RCNG-4363 Fix
            value = undefined;

        this.setState({ value: value, DataDownload: tDD });
    }
    FinalSubmit() {
        if (this.state.rowData.filter(row => row.IsPending != null && row.IsPending == 'E').length > 0) {
            var errorDescription = this.state.rowData.filter(e =>
                e.IsPending != null && e.IsPending === 'E');
            if (errorDescription != undefined && errorDescription != null)
                PopupWindow.showErrorMessage("Alert", errorDescription[0].Tooltip); return; //RCNG-254
        }
        var IsCT4Msg; var IsSekstant;
        var IsMsgFromVessel;
        if (this.state.rowData.filter(row => row.DeviceType != null && row.DeviceType != undefined && row.DeviceType.toString().trim() == 'CT4000').length > 0)
            IsCT4Msg = true;
        else
            IsCT4Msg = false;
        if (this.state.rowData.filter(row => row.VesselCd != null && row.VesselCd != undefined).length > 0)
            IsMsgFromVessel = true;
        else
            IsMsgFromVessel = false;
        if (IsMsgFromVessel == true && IsCT4Msg == true) { PopupWindow.showErrorMessage("Alert", "Command is not supported for vessel."); return }

        if (this.state.rowData.filter(row => row.DeviceType != null && row.DeviceType != undefined && row.DeviceType.toString().trim() == 'Sekstant'
            && row.ReeferOEMTypeCd != null && row.ReeferOEMTypeCd != undefined && row.ReeferOEMTypeCd.toString().trim() == 'S').length > 0) {
            if (this.state.DataDownload.DownloadType == 'StarView')
                IsSekstant = false;
            else
                IsSekstant = true;
        }
        if (IsSekstant == true) { PopupWindow.showErrorMessage("Alert", "Only StarView format is supported"); return }

        var Oemtype = this.state.Filters.SelectedReefers[0].ReeferOEMTypeCd;
        var OemModel = this.state.Filters.SelectedReefers[0].UnitTypeCd;
        if (Oemtype.trim() != "S" && Oemtype.trim() != "D" && Oemtype.trim() != "C") {
            this.state.DataDownload.DownloadType = null;
        }
        else if (Oemtype.trim() == "C") {
            if (this.state.DataDownload.DownloadType == null) {
                if (this.state.isDLDCX == true)
                    this.state.DataDownload.DownloadType = "DCX";
                else
                    this.state.DataDownload.DownloadType = "DL";
            }
            this.state.DataDownload.QueryType = this.state.scopeValue;
            if (this.state.scopeValue == null || this.state.scopeValue == '') {
                this.setState({ scopeValue: "DateRange" });
            }
            else if (this.state.scopeValue != "DateRange") {
                this.state.DataDownload.StartDate = null;
                this.state.DataDownload.EndDate = null;
            }
        }
        else if (this.state.DataDownload.DownloadType == null && isDLBoth) {
            if (Oemtype.trim() == "S")
                this.state.DataDownload.DownloadType = 'DL,StarView';
            if (Oemtype.trim() == "D")
                this.state.DataDownload.DownloadType = 'DL,DCCS';
        }
        if (Oemtype.trim() == "T" && OemModel != "TR") {
            var TempCount = this.state.DataDownload.TempRecordCount;
            var EventCount = this.state.DataDownload.EventRecordCount;
            var TempValidation = "1001";
            if (TempCount.toString() == null || TempCount.toString() == "") {
                PopupWindow.showErrorMessage("Alert", "Number of Temp Counts should not be Empty.");
                return;
            }
            else if (EventCount.toString() == null || EventCount.toString() == "") {
                PopupWindow.showErrorMessage("Alert", "Number of Events Counts should not be Empty.");
                return;
            }
            else if (parseInt(TempCount) == 0) {
                PopupWindow.showErrorMessage("Alert", "Number of Temp Counts should be greater than 0");
                return;
            }
            else if (parseInt(EventCount) == 0) {
                PopupWindow.showErrorMessage("Alert", "Number of Events should be greater than 0");
                return;
            }
            else if (parseInt(TempValidation) <= parseInt(EventCount)) {
                PopupWindow.showErrorMessage("Alert", "Number of Events Counts should not be more than 1000.");
                return;
            }
            else if (parseInt(TempValidation) <= parseInt(TempCount)) {
                PopupWindow.showErrorMessage("Alert", "Number of Temp Counts should not be more than 1000.");
                return;
            }
            else {
                var refreshGrid = this.props.refreshGrid;
                var tDD = this.state.DataDownload;
                var result;
                var errorCount = 0;
                var command = "TraditionalDataDownLoad";
                var emailsEntered = this.state.DataDownload.Emails;
                if (emailsEntered == 'undefined' || emailsEntered == "" || emailsEntered == null) {
                    PopupWindow.showErrorMessage("Email Id(s)", "Please enter Email Id(s)");
                    return;
                }
                if (emailsEntered.includes(",")) {
                    result = false;
                    var Emails = emailsEntered.split(',');
                    Emails.forEach(function (value) {
                        if (value != null || value != "") {
                            result = EmailValidator.validate(value.trim());
                            if (result == false) { errorCount++; }
                        }
                    });
                }
                else {
                    result = EmailValidator.validate(emailsEntered);
                    if (result == false) { errorCount++; }
                }

                if (errorCount > 0) {
                    PopupWindow.showErrorMessage("Email Id(s)", "Please enter valid Email Id(s)"); return;
                }
                else {
                    if (emailsEntered.endsWith(",")) {
                        emailsEntered = emailsEntered.substring(0, emailsEntered.length - 1);
                    }
                    tDD.Emails = emailsEntered;
                    this.setState({ DataDownload: tDD });
                    ReeferCommandsGrid.submitCommands(command, tDD, refreshGrid);
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                }
            }
        }
        else {
            var refreshGrid = this.props.refreshGrid;
            var tDD = this.state.DataDownload;
            var result;
            var errorCount = 0;
            var command = "TraditionalDataDownLoad";
            var emailsEntered = this.state.DataDownload.Emails;
            if (emailsEntered == 'undefined' || emailsEntered == "" || emailsEntered == null) {
                PopupWindow.showErrorMessage("Email Id(s)", "Please enter Email Id(s)");
                return;
            }
            if (emailsEntered.includes(",")) {
                result = false;
                var Emails = emailsEntered.split(',');
                Emails.forEach(function (value) {
                    if (value != null || value != "") {
                        result = EmailValidator.validate(value.trim());
                        if (result == false) { errorCount++; }
                    }
                });
            }
            else {
                result = EmailValidator.validate(emailsEntered);
                if (result == false) { errorCount++; }
            }

            if (errorCount > 0) {
                PopupWindow.showErrorMessage("Email Id(s)", "Please enter valid Email Id(s)"); return;
            }
            else if (errorSubmit == true) {
                PopupWindow.showErrorMessage("Alert", errSubMessage); return;
            }
            else {
                if (emailsEntered.endsWith(",")) {
                    emailsEntered = emailsEntered.substring(0, emailsEntered.length - 1);
                }
                tDD.Emails = emailsEntered;
                this.setState({ DataDownload: tDD });
                ReeferCommandsGrid.submitCommands(command, tDD, refreshGrid);
                this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
            }
        }
    }
    submitDataDownloadCommand() {
        if (this.state.rowData.length > 0)
        {
            var Oemtype = this.state.Filters.SelectedReefers[0].ReeferOEMTypeCd;
            if (Oemtype.trim() == "D" && IsDCCSSupportCount > 0 && IsDLSupportCount > 0 ) {
                $('#confirmModal').show();
            }
            else {
                this.FinalSubmit();
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }

    componentWillReceiveProps(nextprops: any) {
        var Starcoolcount = 0;
        var DaikinCount = 0;
        var CarrierCount = 0;
        var ThermokingCount = 0;
        var UnknownCount = 0;
        var Oem = null;
        this.setState({ IsDateRangeVisible: true }) //RCNG-3852
        reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            if (reeferData.length > 0) {
                $('#globalLoader').show();
                // this.setState({ rowData: reeferData });
                this.setState({ oemTypeCd: reeferData[0].ReeferOEMTypeCd, oemModel: reeferData[0].UnitTypeCd, deviceType: reeferData[0].DeviceType });
                this.setState({ rowData: this.props.reeferData });
                this.getEmails(this.props.userEmail, this.props.customerId);
                dCXDownloads = this.props.dCXDownloads;
                this.ClearDownloadValues();

                if (reeferData[0].DeviceType.trim().toUpperCase() == "TRIPLINK")
                    this.getDeviceTypeValidationTripLink(reeferData, reeferData[0].DeviceType,reeferData[0].ControllerDesc.trim().toUpperCase());
                else
                    this.getDeviceTypeValidation(reeferData, nextprops.reeferFormatter);

                this.renderTDDGrid(reeferData);

            }
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }
    renderTDDGrid(reeferData: any) {
        $('#globalLoader').show();
        this.state.Filters.CommandName = "TraditionalDataDownLoad";
        errorSubmit = false;
        this.state.Filters.SelectedReefers = reeferData;
        this.setState({ rowData: reeferData });
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                //this.setState({ rowData: data, ValidState: data[0].IsValid }); //RCNG-254
                $.each(data, function (key, val) {
                    if (isDateRange) {
                        if (val.DownloadType == "DL" && val.ReeferOEMTypeCd.trim() == "D" && (val.Tooltip == "" || val.Tooltip == null)) {
                            val.IsPending = "U";
                            val.Tooltip ="Date Range not supported.";
                        }
                    }
                });
                this.setState({ rowData: data });
                $('#globalLoader').hide();
            });
    }

    getDeviceTypeValidation(reeferData: any, reeferFormatter: any) {
        IsDCCSSupportCount = 0;
        IsDLSupportCount = 0;
        isDateRange = false;
        if (reeferData != null && reeferData.length > 0) {
            if (!(reeferData[0].ReeferOEMTypeCd == null || reeferData[0].ReeferOEMTypeCd == undefined)) {
                this.setState({IsDateRangeDisabled: false });
                if (reeferData[0].ReeferOEMTypeCd.trim() == "C") {
                    if (dCXDownloads == true && reeferData[0].DeviceType != null && (reeferData[0].DeviceType.trim() == "CT4000" || reeferData[0].DeviceType.trim().toUpperCase() == "TRIPLINK"))
                    {
                        //WI-RCNG-3349 -Added condition for TripLINK
                        this.state.Filters.OtherValue = "DCX";
                        this.setState({ isDLCRReeferConnect: false, isDLDCX: true });
                        this.state.DataDownload.DownloadType = "DCX";
                        ReeferCommandsGrid.UpdateOtherValue("DCX");
                    }
                    else {
                        this.state.Filters.OtherValue = "DL";
                        this.setState({ isDLCRReeferConnect: true, isDLDCX: false });
                        this.state.DataDownload.DownloadType = "DL";
                        ReeferCommandsGrid.UpdateOtherValue("DL");
                    }
                    if (reeferFormatter != null || reeferFormatter != undefined) {
                        var FirmwareSeriesCapabilityList = reeferFormatter.FirmwareSeriesCapabilityList;
                        var FirmwareVersionCapabilityList = reeferFormatter.FirmwareVersionCapabilityList;
                        var DeviceFirmwareVersions = reeferFormatter.DeviceFirmwareVersions;
                        var scopeOptionList = [];
                        var IsDCXSupport = null;
                        var IsReeferConnectSupport = null;
                        var IsDateRangeSupport = null;
                        var IsLastDaysSupport = null;
                        var IsLastestTripSupport = null;
                        var IsEntireLogSupport = null;

                        $.each(reeferData, function (key, val) {
                            var IsVDCXSupport = false;
                            var IsVReeferConnectSupport = false;
                            var IsVDateRangeSupport = false;
                            var IsVLastDaysSupport = false;
                            var IsVLastestTripSupport = false;
                            var IsVEntireLogSupport = false;
                            if (val.RCDFirmwareVersion != null && val.RCDFirmwareVersion != undefined && val.RCDFirmwareVersion != "") {
                                if (val.DeviceType != null && val.DeviceType != "" && val.DeviceType != undefined) {
                                    if (DeviceFirmwareVersions != null && DeviceFirmwareVersions != undefined && DeviceFirmwareVersions.length > 0) {
                                        var FWDescription = lodashfilter(DeviceFirmwareVersions, function (item) {
                                            return item.ShortName.toUpperCase().trim() === val.RCDFirmwareVersion.toUpperCase().trim()
                                                || item.LongName.toUpperCase().trim() === val.RCDFirmwareVersion.toUpperCase().trim()
                                                && item.FirmwareVersionType.toUpperCase().trim() === "MAIN"
                                                && item.DeviceTypeCD.toUpperCase().trim() === val.DeviceType.toUpperCase().trim();
                                        });
                                        if (FWDescription != null && FWDescription.length > 0) {
                                            var FirmwareID = FWDescription[0].FirmwareID;
                                            var FirmwareSeriesId = FWDescription[0].FirmwareSeriesId;

                                            if (FirmwareVersionCapabilityList != null && FirmwareVersionCapabilityList != undefined && FirmwareVersionCapabilityList.length > 0) {
                                                var versionCapabilityList = lodashfilter(FirmwareVersionCapabilityList, function (item) {
                                                    return item.FirmwareId === FirmwareID;
                                                });

                                                if (versionCapabilityList != null && versionCapabilityList.length > 0) {
                                                    var versionCapabilityDCXSupport = lodashfilter(versionCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 1;
                                                    });
                                                    if (versionCapabilityDCXSupport != null && versionCapabilityDCXSupport.length > 0
                                                        && (IsDCXSupport == null || (IsDCXSupport != null && !IsDCXSupport))) {
                                                        if (versionCapabilityDCXSupport[0].IsCapable) {
                                                            IsDCXSupport = true;
                                                        }
                                                        else {
                                                            IsDCXSupport = false;
                                                        }
                                                        IsVDCXSupport = true;
                                                    }
                                                    var versionCapabilityRCSupport = lodashfilter(versionCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 2;
                                                    });
                                                    if (versionCapabilityRCSupport != null && versionCapabilityRCSupport.length > 0
                                                        && (IsReeferConnectSupport == null || (IsReeferConnectSupport != null && !IsReeferConnectSupport))) {
                                                        if (versionCapabilityRCSupport[0].IsCapable) {
                                                            IsReeferConnectSupport = true;
                                                        }
                                                        else {
                                                            IsReeferConnectSupport = false;
                                                        }
                                                        IsVReeferConnectSupport = true;
                                                    }
                                                    var versionCapabilityRange = lodashfilter(versionCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 3;
                                                    });
                                                    if (versionCapabilityRange != null && versionCapabilityRange.length > 0
                                                        && (IsDateRangeSupport == null || (IsDateRangeSupport != null && !IsDateRangeSupport))) {
                                                        if (versionCapabilityRange[0].IsCapable) {
                                                            IsDateRangeSupport = true;
                                                        }
                                                        else {
                                                            IsDateRangeSupport = false;
                                                        }
                                                        IsVDateRangeSupport = true;
                                                    }
                                                    var versionCapabilityLastDays = lodashfilter(versionCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 4;
                                                    });
                                                    if (versionCapabilityLastDays != null && versionCapabilityLastDays.length > 0
                                                        && (IsLastDaysSupport == null || (IsLastDaysSupport != null && !IsLastDaysSupport))) {
                                                        if (versionCapabilityLastDays[0].IsCapable) {
                                                            IsLastDaysSupport = true;
                                                        }
                                                        else {
                                                            IsLastDaysSupport = false;
                                                        }
                                                        IsVLastDaysSupport = true;
                                                    }
                                                    var versionCapabilityLastestTrip = lodashfilter(versionCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 5;
                                                    });
                                                    if (versionCapabilityLastestTrip != null && versionCapabilityLastestTrip.length > 0
                                                        && (IsLastestTripSupport == null || (IsLastestTripSupport != null && !IsLastestTripSupport))) {
                                                        if (versionCapabilityLastestTrip[0].IsCapable) {
                                                            IsLastestTripSupport = true;
                                                        }
                                                        else {
                                                            IsLastestTripSupport = false;
                                                        }
                                                        IsVLastestTripSupport = true;
                                                    }
                                                    var versionCapabilityEntireLog = lodashfilter(versionCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 6;
                                                    });
                                                    if (versionCapabilityEntireLog != null && versionCapabilityEntireLog.length > 0
                                                        && (IsEntireLogSupport == null || (IsEntireLogSupport != null && !IsEntireLogSupport))) {
                                                        if (versionCapabilityEntireLog[0].IsCapable) {
                                                            IsEntireLogSupport = true;
                                                        }
                                                        else {
                                                            IsEntireLogSupport = false;
                                                        }
                                                        IsVEntireLogSupport = true;
                                                    }
                                                }
                                            }

                                            if (FirmwareSeriesCapabilityList != null && FirmwareSeriesCapabilityList != undefined && FirmwareSeriesCapabilityList.length > 0) {
                                                var seriesCapabilityList = lodashfilter(FirmwareSeriesCapabilityList, function (item) {
                                                    return item.FirmwareSeriesId === FirmwareSeriesId;
                                                });

                                                if (seriesCapabilityList != null && seriesCapabilityList.length > 0) {
                                                    var seriesCapabilityDCXSupport = lodashfilter(seriesCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 1;
                                                    });
                                                    if (seriesCapabilityDCXSupport != null && seriesCapabilityDCXSupport.length > 0
                                                        && !IsVDCXSupport && (IsDCXSupport == null || (IsDCXSupport != null && !IsDCXSupport))) {
                                                        if (seriesCapabilityDCXSupport[0].IsCapable) {
                                                            IsDCXSupport = true;
                                                        }
                                                        else {
                                                            IsDCXSupport = false;
                                                        }
                                                    }
                                                    var seriesCapabilityRCSupport = lodashfilter(seriesCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 2;
                                                    });
                                                    if (seriesCapabilityRCSupport != null && seriesCapabilityRCSupport.length > 0
                                                        && !IsVReeferConnectSupport && (IsReeferConnectSupport == null || (IsReeferConnectSupport != null && !IsReeferConnectSupport))) {
                                                        if (seriesCapabilityRCSupport[0].IsCapable) {
                                                            IsReeferConnectSupport = true;
                                                        }
                                                        else {
                                                            IsReeferConnectSupport = false;
                                                        }
                                                    }
                                                    var seriesCapabilityRange = lodashfilter(seriesCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 3;
                                                    });
                                                    if (seriesCapabilityRange != null && seriesCapabilityRange.length > 0
                                                        && !IsVDateRangeSupport && (IsDateRangeSupport == null || (IsDateRangeSupport != null && !IsDateRangeSupport))) {
                                                        if (seriesCapabilityRange[0].IsCapable) {
                                                            IsDateRangeSupport = true;
                                                        }
                                                        else {
                                                            IsDateRangeSupport = false;
                                                        }
                                                    }
                                                    var seriesCapabilityLastDays = lodashfilter(seriesCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 4;
                                                    });
                                                    if (seriesCapabilityLastDays != null && seriesCapabilityLastDays.length > 0
                                                        && !IsVLastDaysSupport && (IsLastDaysSupport == null || (IsLastDaysSupport != null && !IsLastDaysSupport))) {
                                                        if (seriesCapabilityLastDays[0].IsCapable) {
                                                            IsLastDaysSupport = true;
                                                        }
                                                        else {
                                                            IsLastDaysSupport = false;
                                                        }
                                                    }
                                                    var seriesCapabilityLastestTrip = lodashfilter(seriesCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 5;
                                                    });
                                                    if (seriesCapabilityLastestTrip != null && seriesCapabilityLastestTrip.length > 0
                                                        && !IsVLastestTripSupport && (IsLastestTripSupport == null || (IsLastestTripSupport != null && !IsLastestTripSupport))) {
                                                        if (seriesCapabilityLastestTrip[0].IsCapable) {
                                                            IsLastestTripSupport = true;
                                                        }
                                                        else {
                                                            IsLastestTripSupport = false;
                                                        }
                                                    }
                                                    var seriesCapabilityEntireLog = lodashfilter(seriesCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 6;
                                                    });
                                                    if (seriesCapabilityEntireLog != null && seriesCapabilityEntireLog.length > 0
                                                        && !IsVEntireLogSupport && (IsEntireLogSupport == null || (IsEntireLogSupport != null && !IsEntireLogSupport))) {
                                                        if (seriesCapabilityEntireLog[0].IsCapable) {
                                                            IsEntireLogSupport = true;
                                                        }
                                                        else {
                                                            IsEntireLogSupport = false;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        });

                        if (IsLastestTripSupport != null && IsLastestTripSupport) {
                            scopeOptionList.push({ 'key': 'LastTrip', 'value': 'LastTrip', 'display': 'Latest trip' });
                        }
                        if (IsLastDaysSupport != null && IsLastDaysSupport) {
                            scopeOptionList.push({ 'key': 'Last30Days', 'value': 'Last30Days', 'display': 'Last 30 days' });
                            scopeOptionList.push({ 'key': 'Last60Days', 'value': 'Last60Days', 'display': 'Last 60 days' });
                            scopeOptionList.push({ 'key': 'Last90Days', 'value': 'Last90Days', 'display': 'Last 90 days' });
                        }
                        if (IsDateRangeSupport != null && IsDateRangeSupport) {
                            scopeOptionList.push({ 'key': 'DateRange', 'value': 'DateRange', 'display': 'Specific date range' });
                        }
                        if (IsEntireLogSupport != null && IsEntireLogSupport) {
                            scopeOptionList.push({ 'key': 'EntireDatalog', 'value': 'EntireDatalog', 'display': 'Entire log' });
                        }
                        this.setState({ scopeOptions: scopeOptionList });

                        if (scopeOptionList.length > 0) {
                            if (scopeOptionList.length == 1 && IsDateRangeSupport != null && IsDateRangeSupport) {
                                this.setState({ IsScopeVisible: false });
                                this.setState({ scopeValue: "DateRange" });
                            }
                            else {
                                this.setState({ IsScopeVisible: true });
                                if (IsDateRangeSupport != null && !IsDateRangeSupport) {
                                    this.setState({ IsDateRangeVisible: false });
                                }
                                if (IsReeferConnectSupport != null && IsReeferConnectSupport && IsDCXSupport != null && IsDCXSupport) {
                                    this.setState({ scopeValue: "Last30Days", IsDateRangeDisabled: true });
                                }
                                else if (IsReeferConnectSupport != null && !IsReeferConnectSupport && IsDCXSupport != null && IsDCXSupport) {
                                    this.setState({ scopeValue: "Last30Days", IsDateRangeDisabled: true });
                                }
                                else if (IsReeferConnectSupport != null && IsReeferConnectSupport && IsDCXSupport != null && !IsDCXSupport) {
                                    this.setState({ scopeValue: "DateRange", IsDateRangeDisabled: false });
                                }
                                else {
                                    this.setState({ IsDateRangeDisabled: true });
                                    if (IsLastestTripSupport != null && IsLastestTripSupport) {
                                        this.setState({ scopeValue: "LastTrip" });
                                    }
                                    else if (IsEntireLogSupport != null && IsEntireLogSupport) {
                                        this.setState({ scopeValue: "EntireDatalog" });
                                    }
                                }
                            }
                        }
                        else {
                            this.setState({ IsScopeVisible: false });
                            if (IsDateRangeSupport != null && !IsDateRangeSupport) {
                                this.setState({ IsDateRangeVisible: false });
                            }
                        }
                    }
                }
                else if (reeferData[0].ReeferOEMTypeCd.trim() == "D") {
                    var oldControllerTypes: any = [14, 15, 16];//RCNG-4613
                    if (reeferFormatter != null || reeferFormatter != undefined) {
                        var FirmwareSeriesCapabilityList = reeferFormatter.FirmwareSeriesCapabilityList;
                        var FirmwareVersionCapabilityList = reeferFormatter.FirmwareVersionCapabilityList;
                        var DeviceFirmwareVersions = reeferFormatter.DeviceFirmwareVersions;
                        //var IsDCCSSupport = null;

                        $.each(reeferData, function (key, val) {
                            IsDCCSSupport = null;
                            if (val.RCDFirmwareVersion != null && val.RCDFirmwareVersion != undefined && val.RCDFirmwareVersion != "") {
                                if (val.DeviceType != null && val.DeviceType != "" && val.DeviceType != undefined) {
                                    if (DeviceFirmwareVersions != null && DeviceFirmwareVersions != undefined && DeviceFirmwareVersions.length > 0) {
                                        var FWDescription = lodashfilter(DeviceFirmwareVersions, function (item) {
                                            return item.ShortName.toUpperCase().trim() === val.RCDFirmwareVersion.toUpperCase().trim()
                                                || item.LongName.toUpperCase().trim() === val.RCDFirmwareVersion.toUpperCase().trim()
                                                && item.FirmwareVersionType.toUpperCase().trim() === "MAIN"
                                                && item.DeviceTypeCD.toUpperCase().trim() === val.DeviceType.toUpperCase().trim();
                                        });
                                        if (FWDescription != null && FWDescription.length > 0) {
                                            var FirmwareID = FWDescription[0].FirmwareID;
                                            var FirmwareSeriesId = FWDescription[0].FirmwareSeriesId;

                                            if (FirmwareVersionCapabilityList != null && FirmwareVersionCapabilityList != undefined && FirmwareVersionCapabilityList.length > 0) {
                                                var versionCapabilityList = lodashfilter(FirmwareVersionCapabilityList, function (item) {
                                                    return item.FirmwareId === FirmwareID;
                                                });

                                                if (versionCapabilityList != null && versionCapabilityList.length > 0) {
                                                    var versionCapabilityDCCSupport = lodashfilter(versionCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 7;
                                                    });
                                                    if (versionCapabilityDCCSupport != null && versionCapabilityDCCSupport.length > 0) {
                                                        if (versionCapabilityDCCSupport[0].IsCapable && !oldControllerTypes.includes(val.ControllerTypeCd)) {
                                                            IsDCCSSupport = true;
                                                            IsDCCSSupportCount = IsDCCSSupportCount + 1;
                                                            val.DownloadType = "DCCS";
                                                        }
                                                        else {
                                                            IsDLSupportCount = IsDLSupportCount + 1;
                                                            val.DownloadType = "DL";
                                                            IsDCCSSupport = false;
                                                        }
                                                        //IsVDCSSupport = true;
                                                    }
                                                    //else {
                                                    //    if (reeferData[0].DeviceType.trim() == "CT3600") {
                                                    //        IsDCCSSupport = true;
                                                    //        IsVDCSSupport = true;
                                                    //    }
                                                    //}
                                                }
                                            }

                                            if (IsDCCSSupport == null && FirmwareSeriesCapabilityList != null && FirmwareSeriesCapabilityList != undefined && FirmwareSeriesCapabilityList.length > 0) {
                                                var seriesCapabilityList = lodashfilter(FirmwareSeriesCapabilityList, function (item) {
                                                    return item.FirmwareSeriesId === FirmwareSeriesId;
                                                });

                                                if (seriesCapabilityList != null && seriesCapabilityList.length > 0) {
                                                    var seriesCapabilityDCCSupport = lodashfilter(seriesCapabilityList, function (item) {
                                                        return item.FirmwareFeatureId === 7;
                                                    });
                                                    if (seriesCapabilityDCCSupport != null && seriesCapabilityDCCSupport.length > 0) {
                                                        if (seriesCapabilityDCCSupport[0].IsCapable && !oldControllerTypes.includes(val.ControllerTypeCd)) {
                                                            IsDCCSSupport = true;
                                                            IsDCCSSupportCount = IsDCCSSupportCount + 1;
                                                            val.DownloadType = "DCCS";
                                                        }
                                                        else {
                                                            IsDLSupportCount = IsDLSupportCount + 1;
                                                            IsDCCSSupport = false;
                                                            val.DownloadType = "DL";
                                                        }
                                                    }

                                                }
                                                else {
                                                    if (val.DeviceType.trim() == "CT3600" && !oldControllerTypes.includes(val.ControllerTypeCd)) {
                                                        val.DownloadType = "DCCS";
                                                        IsDCCSSupport = true;
                                                        IsDCCSSupportCount = IsDCCSSupportCount + 1;
                                                        //IsVDCSSupport = true;
                                                    }
                                                    else {
                                                        IsDLSupportCount = IsDLSupportCount + 1;
                                                        val.DownloadType = "DL";
                                                        IsDCCSSupport = false;
                                                    }
                                                }
                                            }
                                            else if (IsDCCSSupport == null) {
                                                if (val.DeviceType.trim() == "CT3600" && !oldControllerTypes.includes(val.ControllerTypeCd)) {
                                                    IsDCCSSupport = true;
                                                    IsDCCSSupportCount = IsDCCSSupportCount + 1;
                                                    val.DownloadType = "DCCS";
                                                }
                                                else {
                                                    IsDLSupportCount = IsDLSupportCount + 1;
                                                    IsDCCSSupport = false;
                                                    val.DownloadType = "DL";
                                                }
                                            }
                                        }
                                        else {
                                            if (val.DeviceType.trim() == "CT3600" && !oldControllerTypes.includes(val.ControllerTypeCd)) {
                                                IsDCCSSupport = true;
                                                IsDCCSSupportCount = IsDCCSSupportCount + 1;
                                                val.DownloadType = "DCCS";
                                            }
                                            else {
                                                IsDLSupportCount = IsDLSupportCount + 1;
                                                IsDCCSSupport = false;
                                                val.DownloadType = "DL";
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                if (val.DeviceType.trim() == "CT3600" && !oldControllerTypes.includes(val.ControllerTypeCd)) {
                                    IsDCCSSupport = true;
                                    IsDCCSSupportCount = IsDCCSSupportCount + 1;
                                    val.DownloadType = "DCCS";
                                }
                                else {
                                    IsDLSupportCount = IsDLSupportCount + 1;
                                    IsDCCSSupport = false;
                                    val.DownloadType = "DL";
                                }
                            }
                        });
                        if (IsDCCSSupportCount>0) {
                            var tDD = this.state.DataDownload;
                            IsDCCSSupport = true;
                            tDD.DownloadType = "DCCS";
                            isLastTrip = false;
                            isAllTrip = false;
                            isDateRange = true;
                            tDD.QueryType = "DateRange";
                            this.setState({
                                DataDownload: tDD
                            });
                        }
                        else {
                            var tDD = this.state.DataDownload;
                            IsDCCSSupport = false;
                            tDD.DownloadType = "DL";
                            isLastTrip = true;
                            isAllTrip = false;
                            isDateRange = false;
                            tDD.QueryType = "LastTrip";
                            this.setState({
                                DataDownload: tDD
                            });
                        }
                    }
                }

            }
        }
    }

    getDeviceTypeValidationTripLink(reeferData: any, DeviceType: string, ControllerDesc: string) {

        if (reeferData != null && reeferData.length > 0) {
            if (!(reeferData[0].ReeferOEMTypeCd == null || reeferData[0].ReeferOEMTypeCd == undefined)) {
                if (DeviceType.trim().toUpperCase() == "TRIPLINK") {
                    if (reeferData[0].ReeferOEMTypeCd.trim() == "C") {

                        const { isValidFW, isValidSW } = this.validateFirmwareAndSoftware(reeferData[0].RCDFirmwareVersion, reeferData[0].SoftwareRevision, ControllerDesc);

                        if (isValidFW && isValidSW) {
                            //WI-RCNG-3349 -Added condition for TripLINK
                            this.state.Filters.OtherValue = "DCX";
                            this.setState({ isDLCRReeferConnect: false, isDLDCX: true });
                            this.state.DataDownload.DownloadType = "DCX";
                            ReeferCommandsGrid.UpdateOtherValue("DCX");

                            this.populateScopeOptions(ControllerDesc);

                        }
                        else {
                            this.setState({ ValidState: false });
                        }
                    }
                }
            }
        }
    }

    populateScopeOptions(ControllerDesc: string) {
        var scopeOptionListTripLink = [];
        scopeOptionListTripLink.push({ 'key': 'LastTrip', 'value': 'LastTrip', 'display': 'Latest trip' });

        scopeOptionListTripLink.push({ 'key': 'Last30Days', 'value': 'Last30Days', 'display': 'Last 30 days' });
        scopeOptionListTripLink.push({ 'key': 'Last60Days', 'value': 'Last60Days', 'display': 'Last 60 days' });
        scopeOptionListTripLink.push({ 'key': 'Last90Days', 'value': 'Last90Days', 'display': 'Last 90 days' });

        if (ControllerDesc === "ML5") {
            scopeOptionListTripLink.push({ 'key': 'DateRange', 'value': 'DateRange', 'display': 'Specific date range' });
        }

        scopeOptionListTripLink.push({ 'key': 'EntireDatalog', 'value': 'EntireDatalog', 'display': 'Entire log' });

        this.setState({ IsScopeVisible: true, IsDateRangeDisabled: true, ValidState: true, scopeOptions: scopeOptionListTripLink });
    }

    validateFirmwareAndSoftware(RCDFirmwareVersion: string, SoftwareRevision: string, ControllerDesc: string): { isValidFW: boolean, isValidSW: boolean } {

        //ML3 does not require to check SoftwareRevision and RCDFirmwareVersion
        if (ControllerDesc == "ML3")
            return { isValidFW: true, isValidSW: true };

        let isValidFW = false;
        let isValidSW = false;

        const regexFW = /^\d\.\d{2}$/; //single digit and then two decimal places
        if (!regexFW.test(RCDFirmwareVersion)) {
            PopupWindow.showErrorMessage("Alert", "Device firmware version does not support this command.");
            return { isValidFW, isValidSW };
        } else {
            const DeviceFW = parseFloat(RCDFirmwareVersion);
            if (DeviceFW >= 2.20) {
                isValidFW = true;
            } else {
                PopupWindow.showErrorMessage("Alert", "Device firmware version is not valid.");
                return { isValidFW, isValidSW };
            }
        }

        const regexSW = /^\d{4}$/; //must have 4 digit
        if (!regexSW.test(SoftwareRevision)) {
            PopupWindow.showErrorMessage("Alert", "Controller software version does not support this command.");
            return { isValidFW, isValidSW };;
        } else {
            const ContSWversion = parseInt(SoftwareRevision);
            if (ContSWversion >= 6318) {
                isValidSW = true;
            } else {
                PopupWindow.showErrorMessage("Alert", "Controller software version is not valid.");
                return { isValidFW, isValidSW };;
            }
        }

        return { isValidFW, isValidSW };

    }


    startDateChange(date) {
        var traditionalDownloadStartDate: server.TraditionalDownload = JSON.parse(JSON.stringify(this.state.DataDownload));
        traditionalDownloadStartDate.StartDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM'); //DateFormat(new Date(date), 'MM/dd/yyyy');
        this.setState({ DataDownload: traditionalDownloadStartDate });
    }

    endDateChange(date) {
        var traditionalDownloadEndDate: server.TraditionalDownload = JSON.parse(JSON.stringify(this.state.DataDownload));
        traditionalDownloadEndDate.EndDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM'); //DateFormat(new Date(date), 'MM/dd/yyyy');
        this.setState({ DataDownload: traditionalDownloadEndDate });
    }

    getEmails(useremail, customerId) {
        var url = Config.ApiBaseUrl + '/api/User/GetEmails?userEmail=' + useremail + '&customerId=' + customerId;
        var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'async': 'false' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<Options[]>)
            .then(data => {
                this.setState({ emailOptions: data });
                $('#globalLoader').hide();
            });
    }

    GroupTypeChange(event: React.FormEvent<HTMLInputElement>) {
        var tDD = this.state.DataDownload;
        var Value: string = event.currentTarget.value;
        if (Value == "LastTrip") {
            isLastTrip = true;
            isAllTrip = false;

            tDD.IsChecked = true;
            isDateRange = false;
            if (IsDCCSSupportCount>0)
                tDD.DownloadType = "DCCS";
            else
                tDD.DownloadType = "DL";
            tDD.QueryType = "LastTrip";
            this.setState({
                DataDownload: tDD
            });
            $.each(this.state.rowData, function (key, val) {
                if (val.ReeferOEMTypeCd.trim() == "D" && val.IsPending=="U") {
                    val.IsPending = "";
                    val.Tooltip = "";
                }
            });
        }
        else if (Value == "AllTrips") {
            isLastTrip = false;
            isAllTrip = true;
            tDD.IsChecked = false;
            isDateRange = false;
            if (IsDCCSSupportCount>0)
                tDD.DownloadType = "DCCS";
            else
                tDD.DownloadType = "DL";
            tDD.QueryType = "EntireDatalog";
            tDD.IsChecked = true;
            this.setState({
                DataDownload: tDD
            });
            $.each(this.state.rowData, function (key, val) {
                if (val.ReeferOEMTypeCd.trim() == "D" && val.IsPending == "U") {
                    val.IsPending = "";
                    val.Tooltip = "";
                }
            });
        }
        else {
            isLastTrip = false;
            isAllTrip = false;
            isDateRange = true;
            tDD.DownloadType = "DCCS";
            tDD.QueryType = "DateRange";
            this.setState({
                DataDownload: tDD
            });
            $.each(this.state.rowData, function (key, val) {
                if (val.DownloadType == "DL" && val.ReeferOEMTypeCd.trim() == "D" && (val.Tooltip == "" || val.Tooltip == null)) {
                    val.IsPending = "U";
                    val.Tooltip = "Date Range not supported.";
                }
            });
        }
    }

    SCGroupTypeChange(event: React.FormEvent<HTMLInputElement>) {
        var tDD = this.state.DataDownload;
        var Value: string = event.currentTarget.value;
        if (Value == "DL") {
            isDLReeferConnect = true;
            isDLStarView = false;
            isDLBoth = false;
        }
        else if (Value == "StarView") {
            isDLReeferConnect = false;
            isDLStarView = true;
            isDLBoth = false;
        }
        else {
            isDLReeferConnect = false;
            isDLStarView = false;
            isDLBoth = true;
        }
        tDD.DownloadType = Value;
        this.setState({
            DataDownload: tDD
        });
    }

    /*DaikinGroupTypeChange(event: React.FormEvent<HTMLInputElement>) {
        var tDD = this.state.DataDownload;
        var Value: string = event.currentTarget.value;
        if (Value == "DL") {
            isDLReeferConnect = true;
            isDLDCCS = false;
            isDLBoth = false;
        }
        else if (Value == "DCCS") {
            isDLReeferConnect = false;
            isDLDCCS = true;
            isDLBoth = false;
        }
        else {
            isDLReeferConnect = false;
            isDLDCCS = false;
            isDLBoth = true;
        }
        tDD.DownloadType = Value;
        this.setState({
            DataDownload: tDD
        });
    }*/

    CarrierGroupTypeChange(event: React.FormEvent<HTMLInputElement>) {
        var tDD = this.state.DataDownload;
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        if (Value == "DL") {
            this.setState({ isDLCRReeferConnect: true, isDLDCX: false });
        }
        else if (Value == "DCX") {
            this.setState({ isDLCRReeferConnect: false, isDLDCX: true });
        }
        tDD.DownloadType = Value;
        filters.OtherValue = Value;
        ReeferCommandsGrid.UpdateOtherValue(Value);
        this.setState({
            DataDownload: tDD, Filters: filters
        }, () =>
            this.renderTDDGrid(this.props.reeferData));
    }

    ScopeChange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value;
        this.setState({ scopeValue: Value });
        if (Value == "DateRange") {
            this.setState({ IsDateRangeDisabled: false });
        }
        else {
            this.setState({ IsDateRangeDisabled: true });
        }
    }

    TempCountsChange(event: React.FormEvent<HTMLInputElement>) {
        var tDD = this.state.DataDownload;
        var Value: string = event.currentTarget.value.trim();
        tDD.TempRecordCount = parseInt(Value).toString();
        if (tDD.TempRecordCount.toString() == "NaN") {
            tDD.TempRecordCount = "";
        }

        this.setState({
            DataDownload: tDD
        });
    }

    EventCountChange(event: React.FormEvent<HTMLInputElement>) {
        var tDD = this.state.DataDownload;
        var Value: string = event.currentTarget.value.trim();
        tDD.EventRecordCount = parseInt(Value).toString();
        if (tDD.EventRecordCount.toString() == "NaN") {
            tDD.EventRecordCount = "";
        }
        this.setState({
            DataDownload: tDD
        });
        oldEventCount = parseInt(Value);
    }

    //isNumber(value) {
    //    return typeof value === 'number' && isFinite(value);
    //}   

    ClearDownloadValues() {
        var filterSet = new ForwardCommandParams();
        var startDate = new Date();
        startDate.setDate(startDate.getDate() + -1).toLocaleString();
        var endDate = new Date();
        endDate.setDate(endDate.getDate()).toLocaleString();
        isLastTrip = true;
        isAllTrip = false;
        isDateRange = false;
        IsDCCSSupport = null;
        IsDCCSSupportCount = 0;
        IsDLSupportCount = 0;
        isDLReeferConnect = false;
        isDLStarView = false;
        isDLDCCS = false;
        isDLBoth = true;
        var filter: server.TraditionalDownload = {
            StartDate: startDate, EndDate: endDate, IsChecked: true, TempRecordCount: '1000', EventRecordCount: '1000', Emails: "", DownloadType: null, QueryType: null
        };
        this.setState({ DataDownload: filter, emailOptions: [], value: [], removeSelected: true });
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    }
    performYesAction() {
        this.closeModel();
        this.FinalSubmit();
    }
    closeModel() {
        $('#confirmModal').hide();
    }
    performNoAction() {
        this.closeModel();
    }
    public render() {
        var DateRangedisabled: any;
        if (IsDCCSSupportCount>0) {
            DateRangedisabled = false;
        }
        else {
            DateRangedisabled = true;
        }
        return <div>
            <div className="modal-controls-container">
                {
                    this.state.oemTypeCd.trim() == "D" || (this.state.oemTypeCd.trim() == "T" && this.state.oemModel == "TR") ?
                        <div className="row">

                            <div className="col-md-3 text-sm-end pe-0">

                                <div className="form-check form-check-inline">
                                    <input type="radio" className='form-check-input' name="SearchCriteria" value="LastTrip" checked={isLastTrip} onChange={e => this.GroupTypeChange(e)} />
                                    <label className="form-check-label">Last Trip</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input type="radio" className='form-check-input' name="SearchCriteria" value="AllTrips" checked={isAllTrip} onChange={e => this.GroupTypeChange(e)} />
                                    <label className="form-check-label">All Trips</label>
                                </div>

                            </div>

                            <div className="col-md-9">


                                {this.state.oemTypeCd.trim() == "D" ?
                                    <div className='row'>
                                        <div className="col-md-3">
                                            <div className="form-check form-check-inline">
                                                <input type="radio" className='form-check-input' disabled={DateRangedisabled} name="SearchCriteria" value="DataRange" checked={isDateRange} onChange={e => this.GroupTypeChange(e)} />
                                                <label className="form-check-label">Date Range</label>
                                            </div>
                                        </div>



                                        <div className="col-md-2 text-sm-end pe-0"> <label className='col-form-label'>Start Date : </label> </div>
                                        <div className="col-md-2">
                                            <DatePicker
                                                selected={new Date(this.state.DataDownload.StartDate)}
                                                maxDate={new Date(Date.now())}
                                                onChange={this.startDateChange.bind(this)}
                                                dateFormat="MM/dd/yyyy"
                                                className=""
                                                disabled={DateRangedisabled}
                                            />

                                        </div>
                                        <div className="col-md-2 text-sm-end pe-0"><label className='col-form-label'> End Date : </label> </div>
                                        <div className="col-md-2">
                                            <DatePicker
                                                selected={new Date(this.state.DataDownload.EndDate)}
                                                maxDate={new Date(Date.now())}
                                                onChange={this.endDateChange.bind(this)}
                                                dateFormat="MM/dd/yyyy"
                                                className=""
                                                disabled={DateRangedisabled}
                                            />
                                        </div>
                                    </div>
                                    : <div />
                                }


                            </div>

                            <div className="row mt-2">
                                <div className="col-md-2 text-sm-end pe-0"> <label className='col-form-label'>Select Email Id(s) : </label></div>
                                <div className="col-md-10">
                                    <Select.Creatable
                                        closeOnSelect={!this.state.stayOpen}
                                        disabled={this.state.disabled}
                                        multi
                                        onChange={this.handleSelectChange.bind(this)}
                                        options={this.state.emailOptions}
                                        placeholder="Select"
                                        removeSelected={this.state.removeSelected}
                                        rtl={this.state.rtl}
                                        simpleValue
                                        value={this.state.value}
                                        height={60}
                                        allowCreate={true}
                                        showNewOptionAtTop={true}
                                        classNamePrefix="Emaillist4"
                                        className="setEmail4"
                                    />
                                </div>
                            </div>
                        </div>
                        : this.state.oemTypeCd.trim() == "T" ?
                            <div>
                                <div className="row">
                                    <div className="col-md-2 text-sm-end pe-0"> <label className='col-form-label'>Number of Temp Counts :</label> </div>
                                    <div className="col-md-3"> <input type="text" name="TempCounts" className='form-control' value={this.state.DataDownload.TempRecordCount} onChange={e => this.TempCountsChange(e)} /> </div>

                                    <div className="col-md-3 pe-0 text-md-end"> <label className='col-form-label'>Number of Events Counts :</label></div>
                                    <div className="col-md-3 "> <input type="text" name="EventCounts" className='form-control' value={this.state.DataDownload.EventRecordCount} onBlur={e => this.EventCountChange(e)} onChange={e => this.EventCountChange(e)} /></div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-2 text-sm-end pe-0"> <label className='col-form-label'>Select Email Id(s) : </label></div>
                                    <div className="col-md-10">
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.handleSelectChange.bind(this)}
                                            options={this.state.emailOptions}
                                            placeholder="Select"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.value}
                                            height={60}
                                            allowCreate={true}
                                            showNewOptionAtTop={true}
                                            classNamePrefix="Emaillist3"
                                            className="setEmail3"
                                        />
                                    </div>
                                </div>
                            </div>
                            : this.state.oemTypeCd.trim() == "S" ?
                                <div>
                                    <div className="row">
                                        <div className="col-md-2 text-sm-end pe-0"> <label className='col-form-label'>Start Date : </label> </div>
                                        <div className="col-md-2">
                                            <DatePicker
                                                selected={new Date(this.state.DataDownload.StartDate)}
                                                maxDate={new Date(Date.now())}
                                                onChange={this.startDateChange.bind(this)}
                                                dateFormat="MM/dd/yyyy"
                                                className=""
                                            />

                                        </div>
                                        <div className="col-md-1 px-0"><label className='col-form-label'> End Date : </label> </div>
                                        <div className="col-md-2">
                                            <DatePicker
                                                selected={new Date(this.state.DataDownload.EndDate)}
                                                maxDate={new Date(Date.now())}
                                                onChange={this.endDateChange.bind(this)}
                                                dateFormat="MM/dd/yyyy"
                                                className=""
                                            />
                                        </div>
                                        <div className="col-md-1 px-0"><span className='col-form-label'> Format(s):</span></div>
                                        <div className="col-md-4">
                                            <div className="input-group">


                                                <div className="form-check form-check-inline">
                                                    <input type="radio" className="form-check-input" value="DL" checked={isDLReeferConnect} onChange={e => this.SCGroupTypeChange(e)} />
                                                    <label className="form-check-label">Maritime platform</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input type="radio" className="form-check-input" value="StarView" checked={isDLStarView} onChange={e => this.SCGroupTypeChange(e)} />
                                                    <label className="form-check-label">StarView</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input type="radio" className="form-check-input" value="DL,StarView" checked={isDLBoth} onChange={e => this.SCGroupTypeChange(e)} />
                                                    <label className="form-check-label">Both</label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-2 text-sm-end pe-0"> <span className='col-form-label'>Select Email Id(s) : </span></div>
                                        <div className="col-md-10 width78">
                                            <Select.Creatable
                                                closeOnSelect={!this.state.stayOpen}
                                                disabled={this.state.disabled}
                                                multi
                                                onChange={this.handleSelectChange.bind(this)}
                                                options={this.state.emailOptions}
                                                placeholder="Select"
                                                removeSelected={this.state.removeSelected}
                                                rtl={this.state.rtl}
                                                simpleValue
                                                value={this.state.value}
                                                height={60}
                                                allowCreate={true}
                                                showNewOptionAtTop={true}
                                                classNamePrefix="Emaillist2"
                                                className="setEmail2"
                                            />
                                        </div>
                                    </div>
                                </div>

                                : this.state.oemTypeCd.trim() == "C" ?
                                    <div>
                                        <div className="row">
                                            {
                                                this.state.IsScopeVisible == true ?
                                                    <div className="row">
                                                        <div className="col-md-2 text-sm-end pe-0"> <label className='col-form-label'>Scope : </label> </div>
                                                        <div className="col-md-4">
                                                            <select className='form-select' id='selectScope' onChange={e => this.ScopeChange(e)} value={this.state.scopeValue}>
                                                                {this.state.scopeOptions.map((scopeOption) => <option key={scopeOption.key} value={scopeOption.value}>{scopeOption.display}</option>)}
                                                            </select>
                                                        </div>
                                                    </div> : <div />
                                            }
                                            {(dCXDownloads == true && this.state.deviceType != null && this.state.deviceType.trim() == "CT4000") ?
                                                <div className="row mt-2">
                                                    <div className="col-md-2 text-sm-end pe-0"><span className='col-form-label'> Format(s) :</span></div>
                                                    <div className="col-md-4">
                                                        <div className="input-group">
                                                            <div className="form-check form-check-inline">
                                                                <input type="radio" className="form-check-input" value="DL" checked={this.state.isDLCRReeferConnect} onChange={e => this.CarrierGroupTypeChange(e)} />
                                                                <label className="form-check-label">Maritime platform</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input type="radio" className="form-check-input" id="rdoDCX" value="DCX" checked={this.state.isDLDCX} onChange={e => this.CarrierGroupTypeChange(e)} />
                                                                <label className="form-check-label">DCX</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : <div />
                                            }
                                        </div>
                                        {
                                            this.state.IsDateRangeVisible == true ?
                                                <div className="row mt-2">
                                                    <div className="col-md-2 text-sm-end pe-0"> <label className='col-form-label'>Start Date : </label> </div>
                                                    <div className="col-md-4">
                                                        <DatePicker
                                                            selected={new Date(this.state.DataDownload.StartDate)}
                                                            maxDate={new Date(Date.now())}
                                                            onChange={this.startDateChange.bind(this)}
                                                            dateFormat="MM/dd/yyyy"
                                                            className=""
                                                            disabled={this.state.IsDateRangeDisabled}
                                                        />
                                                    </div>
                                                    <div className="col-md-2 text-sm-end pe-0"><label className='col-form-label'> End Date : </label> </div>
                                                    <div className="col-md-4">
                                                        <DatePicker
                                                            selected={new Date(this.state.DataDownload.EndDate)}
                                                            maxDate={new Date(Date.now())}
                                                            onChange={this.endDateChange.bind(this)}
                                                            dateFormat="MM/dd/yyyy"
                                                            className=""
                                                            disabled={this.state.IsDateRangeDisabled}
                                                        />
                                                    </div>
                                                </div> : <div />
                                        }
                                        <div className="row mt-2">
                                            <div className="col-md-2 text-sm-end pe-0"> <label className='col-form-label'>Select Email Id(s) : </label></div>
                                            <div className="col-md-10">
                                                <Select.Creatable
                                                    closeOnSelect={!this.state.stayOpen}
                                                    disabled={this.state.disabled}
                                                    multi
                                                    onChange={this.handleSelectChange.bind(this)}
                                                    options={this.state.emailOptions}
                                                    placeholder="Select"
                                                    removeSelected={this.state.removeSelected}
                                                    rtl={this.state.rtl}
                                                    simpleValue
                                                    value={this.state.value}
                                                    height={60}
                                                    allowCreate={true}
                                                    showNewOptionAtTop={true}
                                                    classNamePrefix="Emaillist2"
                                                    className="setEmail2"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    :
                                    <div>
                                        <div className="row">
                                            <div className="col-md-2 text-sm-end pe-0"> <label className='col-form-label'>Start Date : </label> </div>
                                            <div className="col-md-4">
                                                <DatePicker
                                                    selected={new Date(this.state.DataDownload.StartDate)}
                                                    maxDate={new Date(Date.now())}
                                                    onChange={this.startDateChange.bind(this)}
                                                    dateFormat="MM/dd/yyyy"
                                                    className=""
                                                />

                                            </div>
                                            <div className="col-md-1 px-0"><label className='col-form-label'> End Date : </label> </div>
                                            <div className="col-md-4">
                                                <DatePicker
                                                    selected={new Date(this.state.DataDownload.EndDate)}
                                                    maxDate={new Date(Date.now())}
                                                    onChange={this.endDateChange.bind(this)}
                                                    dateFormat="MM/dd/yyyy"
                                                    className=""
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-md-2 text-sm-end pe-0"> <label className='col-form-label'>Select Email Id(s) : </label></div>
                                            <div className="col-md-10">
                                                <Select.Creatable
                                                    closeOnSelect={!this.state.stayOpen}
                                                    disabled={this.state.disabled}
                                                    multi
                                                    onChange={this.handleSelectChange.bind(this)}
                                                    options={this.state.emailOptions}
                                                    placeholder="Select"
                                                    removeSelected={this.state.removeSelected}
                                                    rtl={this.state.rtl}
                                                    simpleValue
                                                    value={this.state.value}
                                                    height={60}
                                                    allowCreate={true}
                                                    showNewOptionAtTop={true}
                                                    classNamePrefix="Emaillist1"
                                                    className="setEmail1"
                                                />
                                            </div>
                                        </div>
                                    </div>
                }


            </div>
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} selectedReefers={this.state.rowData} commandName={"TraditionalDataDownLoad"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">

                <button type="button" id="Hide_TraditionalDataDownLoad" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                {
                    this.state.ValidState == true ?
                        <button type='button' onClick={this.submitDataDownloadCommand.bind(this)} className='btn btn-primary'>Save</button>
                        :
                        <button type='button' disabled className='btn btn-primary'>Save</button>
                }
            </div>
            <div className="modal" role="dialog" id="confirmModal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={this.closeModel.bind(this)}><span aria-hidden="true">&times;</span></button>

                        </div>
                        <div className="modal-body">
                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <div className="alert-text">
                                        The selected reefers has different DL type. Command will be sent with respect to either DL or DCCS type. Do you want to continue?
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="modal-footer mt-2">
                            <button type="button" className="btn btn-secondary" onClick={() => this.performNoAction()} >No</button>
                            <button type="button" className="btn btn-primary" onClick={() => this.performYesAction()}  >Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

class ForwardCommandParams {
    SelectedReefers: server.USP_UnitCurrentConditionUI_Model[];
    CommandName: string;
    TempValue: any;
    TraditionalDownload: server.TraditionalDownload;
    OtherValue: string;
}


